import React, { useEffect, useState } from "react";
import { Card, Col, Container, Image, Row } from "react-bootstrap";
import home_card1 from "../assets/images/home_card1.svg";
import companiesLogo from "../assets/images/companiesLogo.png";
import companies_gray_1 from "../assets/images/companies_gray_1.png";
import companies_gray_2 from "../assets/images/companies_gray_2.png";
import companies_gray_3 from "../assets/images/companies_gray_3.png";
import Formb from "../Components/Formb";
import ReactPlayer from "react-player/lazy";

import Button from "@restart/ui/esm/Button";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import { color } from "@mui/system";
import { Get } from "../Axios/AxiosFunctions";
import { URL, imageUrl } from "../Config/apiUrl";
import BodyLoader from "../Components/BodyLoader";

const Companies = () => {
  const history = useHistory();
  const [isApiCall, setIsApiCall] = useState(true);
  const [pageData, setPageData] = useState(null);
  const [allServices, setAllServices] = useState([]);
  const [allServicesCompany, setAllServicesCompany] = useState([]);
  const [allServicesGoal, setAllServicesGoal] = useState([]);
  const array = [
    {
      pic: home_card1,
      title: "Hire an employee",
      des: "As you probably know it with traditional temp agencies, you can always hire an employee for a shorter or longer period. Here we have just cut away all the superfluous and digitized the whole process for you.",
    },
    {
      pic: home_card1,
      title: "Try and Hire",
      des: "You can choose to hire the employee for a period of time to clarify whether it is the right candidate for a permanent job in your company.",
    },
    {
      pic: home_card1,
      title: "Direct employment",
      des: "Our screening tools are so powerful that several companies are offering our graduates permanent employment from day 1.",
    },
  ];

  const arrayLogo = [
    { logo: companiesLogo },
    { logo: companiesLogo },
    { logo: companiesLogo },
    { logo: companiesLogo },
    { logo: companiesLogo },
    { logo: companiesLogo },
    { logo: companiesLogo },
    { logo: companiesLogo },
  ];

  const arrayGray = [
    { icon: companies_gray_1, text: "Create your company profile" },
    { icon: companies_gray_2, text: "Search & explore desired employee" },
    { icon: companies_gray_3, text: "Hire employee on 3 options" },
  ];

  // getdata
  const getdata = async () => {
    const url = URL("general/web/selected-page?name=company");
    const response = await Get(url);
    if (response !== undefined) {
      setPageData(response?.data?.data?.company);
      setAllServices(response?.data?.allServices);
      setAllServicesCompany(response?.data?.allServicesCompany);
      setAllServicesGoal(response?.data?.allServicesGoal);
    }

    setIsApiCall(false);
  };

  useEffect(() => {
    getdata();
  }, []);

  if (isApiCall) {
    return <BodyLoader />;
  }

  return (
    <div>
      <Container
        fluid
        className="Companies_bg"
        style={{
          "background-image": `url(${imageUrl}${pageData?.cover_image})`, textAlign:"center"
        }}
      >
        <Row>
          <Col>
            <h2 className="mb-4 whito">
              {/* <span className="regular">Do you need new </span>
              temporary or <br /> permanent employees? */}
              {pageData?.heading}
            </h2>
            <h5 className="whito mt-4">{pageData?.detail_description}</h5>
          </Col>
        </Row>
      </Container>
      <Container className="small_container">
        <Row>
          <Col>
            <h3 className="text-center mt-5">
              {pageData?.sec1Heading1}
              {/* <span className="regular ">
                {" "}
                At JOBSTER, as a company, you have{" "}
              </span>{" "}
              3 different options<span className="regular">
                {" "}
                in terms of{" "}
              </span>{" "}
              finding your new employees. */}
            </h3>
            <h5 className="text-center mt-3 mb-5">
              {pageData?.sec1Description}
            </h5>
          </Col>
        </Row>
        <Row>
          {allServices.map((item, i) => {
            return (
              <Col  md={4} key={item?._id}>
                <Card className="home_card1 home_card_main companies_card">
                  <div className="img_div">
                    <Card.Img
                      variant="top"
                      src={`${imageUrl}${item?.icon}`}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = home_card1;
                      }}
                    />
                  </div>
                  <Card.Body>
                    <Card.Title className="mb-4">
                      <h4> {item?.title} </h4>
                    </Card.Title>
                    <Card.Text>{item?.description}</Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            );
          })}
          <div className="text-center mt-5 mb-5 companies_blue_btn">
            <Button>
              <Link
                to="/signup"
                className="footerLink"
                style={{ color: "white" }}
              >
                Create your company profile
              </Link>
            </Button>
          </div>
        </Row>
      </Container>
      <Container className="small_container">
        <Row>
          <Col>
            <h3 className="text-center mt-5 mb-5">
              {pageData?.sec1Heading2}
              {/* <span className="regular">
                These companies have already used &nbsp;
              </span>
              our service
              <span className="regular">&nbsp; and &nbsp;</span>
              found their dream employees */}
            </h3>
          </Col>
        </Row>

        <Row className="company_logo_row">
          {allServicesCompany.map((item, i) => {
            return (
              <Col key={item?._id} className="mb-4 company_logo_r">
                <Image src={`${imageUrl}${item?.icon}`} />
              </Col>
            );
          })}
        </Row>
      </Container>
      <div className="companies_gray_bg ">
        <Container className="small_container">
          <Row>
            <Col>
              <h3 className="text-center">
                {pageData?.sec2Heading}
                {/* <span className="regular"> How easy it is to</span> set up{" "}
                <span className="regular">&nbsp; and &nbsp;</span>
                <br /> find new employees */}
              </h3>
            </Col>
          </Row>
          <Row className="mt-5 ">
            {allServicesGoal.map((item, i) => {
              return (
                <Col className="find-job-card" md={4} key={item?._id}>
                  <Image fluid src={`${imageUrl}${item?.icon}`} />
                  <h5 className="companies_gray_h5_styling">{item?.title}</h5>
                </Col>
              );
            })}
            <div className="text-center mt-5  companies_blue_btn">
              <Button>
                <Link
                  to="/signup"
                  className="footerLink"
                  style={{ color: "white" }}
                >
                  Create your company profile
                </Link>
              </Button>
            </div>
          </Row>
        </Container>
      </div>

      <Container className="small_container">
        <Row>
          <Col>
            <h3 className="text-center mt-5">
              {pageData?.sec3Heading}
              {/* What people say's <span className="regular"> about JOBSTER </span> */}
            </h3>
          </Col>
        </Row>
        <Row className="mt-5">
          <Col md={6}>
            <ReactPlayer
              url={`${imageUrl}${pageData?.sec3Video1}`}
              className="html5_video companies"
              controls
            />
            <Col className="companies_video_box">
              <h4>{pageData?.sec3Name1}</h4>
              <p className="big_p">{pageData?.sec3Company1}</p>
            </Col>
          </Col>
          <Col md={6}>
            <ReactPlayer
              url={`${imageUrl}${pageData?.sec3Video1}`}
              className="html5_video companies"
              controls
            />

            <Col className="companies_video_box">
              <h4>{pageData?.sec3Name2}</h4>
              <p className="big_p">{pageData?.sec3Company2}</p>
            </Col>
          </Col>
        </Row>
      </Container>

      <Container>
        <Row>
          <Col md={6}></Col>
        </Row>
      </Container>

      <Formb />
    </div>
  );
};

export default Companies;
